import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconShoppingBag_14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H23.3337C23.7479 11.25 24.0837 11.5858 24.0837 12V30.5719C24.0837 30.9861 23.7479 31.3219 23.3337 31.3219H4C3.58579 31.3219 3.25 30.9861 3.25 30.5719V12ZM4.75 12.75V29.8219H22.5837V12.75H4.75Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.82 16.2856C22.82 15.8714 23.1557 15.5356 23.57 15.5356H29.0463C29.3304 15.5356 29.5901 15.6961 29.7171 15.9502L32.4625 21.4411L35.0961 22.7579C35.3502 22.8849 35.5107 23.1446 35.5107 23.4287V30.5717C35.5107 30.9859 35.1749 31.3217 34.7607 31.3217H23.0938C22.6795 31.3217 22.3438 30.9859 22.3438 30.5717C22.3438 30.1575 22.6795 29.8217 23.0938 29.8217H34.0107V23.8922L31.5681 22.6709C31.4229 22.5983 31.3052 22.4806 31.2327 22.3355L28.5828 17.0356H23.57C23.1557 17.0356 22.82 16.6999 22.82 16.2856Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0941 30.5717C12.0941 31.8867 11.028 32.9527 9.71304 32.9527C8.39805 32.9527 7.33203 31.8867 7.33203 30.5717C7.33203 29.2567 8.39805 28.1907 9.71304 28.1907C11.028 28.1907 12.0941 29.2567 12.0941 30.5717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.71304 28.9407C8.81226 28.9407 8.08203 29.6709 8.08203 30.5717C8.08203 31.4725 8.81226 32.2027 9.71304 32.2027C10.6138 32.2027 11.3441 31.4725 11.3441 30.5717C11.3441 29.6709 10.6138 28.9407 9.71304 28.9407ZM6.58203 30.5717C6.58203 28.8425 7.98383 27.4407 9.71304 27.4407C11.4423 27.4407 12.8441 28.8425 12.8441 30.5717C12.8441 32.3009 11.4423 33.7027 9.71304 33.7027C7.98383 33.7027 6.58203 32.3009 6.58203 30.5717Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.43 30.5717C31.43 31.8867 30.364 32.9527 29.049 32.9527C27.734 32.9527 26.668 31.8867 26.668 30.5717C26.668 29.2567 27.734 28.1907 29.049 28.1907C30.364 28.1907 31.43 29.2567 31.43 30.5717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.049 28.9407C28.1482 28.9407 27.418 29.6709 27.418 30.5717C27.418 31.4725 28.1482 32.2027 29.049 32.2027C29.9498 32.2027 30.68 31.4725 30.68 30.5717C30.68 29.6709 29.9498 28.9407 29.049 28.9407ZM25.918 30.5717C25.918 28.8425 27.3198 27.4407 29.049 27.4407C30.7782 27.4407 32.18 28.8425 32.18 30.5717C32.18 32.3009 30.7782 33.7027 29.049 33.7027C27.3198 33.7027 25.918 32.3009 25.918 30.5717Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 12.75C16.5 17.0302 13.0302 20.5 8.75 20.5C4.46979 20.5 1 17.0302 1 12.75C1 8.46979 4.46979 5 8.75 5C13.0302 5 16.5 8.46979 16.5 12.75Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.59717 16.375H7.21138V9.25049H5.79645L4.15234 10.4163V11.7914L5.59717 10.8448V16.375Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3854 16.375H12.9498V14.96H13.8864V13.8042H12.9498V9.25049H10.9669L7.88794 14.3721V14.96H11.3854V16.375ZM9.50215 13.8042L11.4153 10.4661V13.8042H9.50215Z",
  fill: "white"
}));
export { IconShoppingBag_14 };